import { render, staticRenderFns } from "./FilterForm.vue?vue&type=template&id=0876afea&scoped=true&"
import script from "./FilterForm.vue?vue&type=script&lang=js&"
export * from "./FilterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876afea",
  null
  
)

export default component.exports